import React from "react";
import { withRouter } from "react-router-dom";
import {
  Form,
  FormInput,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "shards-react";

import { openSecretPage } from "./../../../utils/secretSearch";

const SidebarSearch = ({ history }) => (
  <Form
    className="main-sidebar__search w-100 border-right d-sm-flex d-md-none d-lg-none"
    style={{ display: "flex", minHeight: "45px" }}
    onSubmit={event => event.preventDefault()}
  >
    <InputGroup seamless className="ml-3">
      <InputGroupAddon type="prepend">
        <InputGroupText>
          <i className="material-icons">search</i>
        </InputGroupText>
        <FormInput
          className="navbar-search"
          placeholder="Vyhledat..."
          aria-label="Search"
          onChange={event => openSecretPage(event.target.value, history)}
        />
      </InputGroupAddon>
    </InputGroup>
  </Form>
);

export default withRouter(SidebarSearch);
